/**
 * documentextensionactions.js
 * Created by calhosh on 10/22/2020.
 */
import Utility from '../../util/utilityfunctions';
import {CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT, GET_ALL_DOCUMENT_EXTENSION, UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT} from '../actiontypes';

export function getAllDocumentExtensions(engagementId, documentId) {
	return {
		type: GET_ALL_DOCUMENT_EXTENSION,
		meta: {
			api: {
				url: Utility.getDocumentChangeReasonApiUrl(engagementId, documentId),
				method: 'GET'
			}
		},
		resolve: true
	};
}

export function createDocumentChangeComment(engagementId, documentId, data) {
	return {
		type: CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT,
		meta: {
			api: {
				url: Utility.getDocumentChangeReasonApiUrl(engagementId, documentId),
				method: 'POST',
				data: data
			}
		}
	};
}

export function updateDocumentChangeComment(engagementId, documentId, documentExtensionId, data) {
	return {
		type: UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT,
		meta: {
			api: {
				url: Utility.getDocumentChangeReasonApiUrl(engagementId, documentId) + documentExtensionId,
				method: 'PATCH',
				data: data
			}
		}
	};
}
